import { render, staticRenderFns } from "./ProductQuickEdit.vue?vue&type=template&id=748e2d82&scoped=true"
import script from "./ProductQuickEdit.vue?vue&type=script&lang=js"
export * from "./ProductQuickEdit.vue?vue&type=script&lang=js"
import style0 from "./ProductQuickEdit.vue?vue&type=style&index=0&id=748e2d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748e2d82",
  null
  
)

export default component.exports